import { render, staticRenderFns } from "./detail-actions.vue?vue&type=template&id=35559dec&scoped=true"
import script from "./detail-actions.vue?vue&type=script&lang=js"
export * from "./detail-actions.vue?vue&type=script&lang=js"
import style0 from "./detail-actions.vue?vue&type=style&index=0&id=35559dec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35559dec",
  null
  
)

export default component.exports